import { CdkScrollable, ScrollDispatcher } from '@angular/cdk/scrolling';
import {
  AfterViewInit,
  DestroyRef,
  Directive,
  inject,
  input,
  numberAttribute,
  output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  standalone: true,
  selector: '[cheeleeInfiniteScroll]',
})
export class InfiniteScrollDirective implements AfterViewInit {
  readonly targetToFire = input(0.1, { transform: numberAttribute });

  readonly scrolled = output<void>();

  private isFired = false;

  private readonly scrollDispatcher = inject(ScrollDispatcher);

  private readonly destroyRef = inject(DestroyRef);

  public ngAfterViewInit(): void {
    this.scrollDispatcher
      .scrolled()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((cs: CdkScrollable | void) => this.handleScrollEvent(cs));
  }

  private handleScrollEvent(cs?: CdkScrollable | void): void {
    if (!cs) {
      return;
    }

    const contentHeight = cs.getElementRef().nativeElement.scrollHeight;
    const scrolledUntilNow = cs.measureScrollOffset('bottom');
    const scrolledPercent = scrolledUntilNow / contentHeight;

    if (scrolledPercent <= this.targetToFire()) {
      if (!this.isFired) {
        this.isFired = true;
        this.scrolled.emit();
      }
    } else {
      this.isFired = false;
    }
  }
}
